/**
 * 메인 테이블 Progress 컬럼의 뱃지 구성.
 *
 * shipment type(`tabValue`)별로 노출 뱃지와 순서가 다를 뿐 렌더 방식은 동일하므로,
 * 차이를 전부 여기 데이터로 모으고 렌더는 `CommonMainDef`의 `progressCol`이 담당한다.
 *
 * - `badge`     : 뱃지에 찍히는 약어
 * - `label`     : 헤더 물음표 툴팁에 `약어: label` 형태로 표시
 * - `noteKeys`  : 이 뱃지에 묶이는 note의 `note_entry` 값들 (툴팁 내용·외곽선 판정)
 * - `todoKeys`  : 진행 색상 계산에 쓰는 todo 키들. 생략하면 `noteKeys`와 동일
 */
export const progressBadges = {
    /** Ocean Import */
    0: [
        { badge: 'PA', label: 'Pre Alert', noteKeys: ['pre_alert'] },
        { badge: 'I', label: 'ISF Filing', noteKeys: ['isf'] },
        { badge: 'AN', label: 'Arrival Notice', noteKeys: ['arrival_notice'] },
        {
            badge: 'M',
            label: 'MBL Release, Collect Charge',
            noteKeys: ['ocean_freight'],
            todoKeys: ['mbl_release', 'ocean_freight'],
        },
        { badge: 'H', label: 'HBL Release', noteKeys: ['hbl_release'] },
        { badge: 'C', label: 'Customs', noteKeys: ['customs'], todoKeys: ['customs', 'customs_hold'] },
        { badge: 'DO', label: 'Delivery Order', noteKeys: ['delivery_order'] },
        { badge: 'PP', label: 'Pier Pass', noteKeys: ['pierpass'] },
        { badge: 'E', label: 'Empty', noteKeys: ['empty'] },
        { badge: 'IV', label: 'Invoice', noteKeys: ['invoice'] },
        { badge: 'CD', label: 'Credit/Debit Statement', noteKeys: ['crdr'] },
    ],
    /** Ocean Export */
    1: [
        { badge: 'BK', label: 'Booking Confirmation', noteKeys: ['booking_confirmation'] },
        { badge: 'DO', label: 'Delivery Order', noteKeys: ['delivery_order'] },
        { badge: 'PP', label: 'Pier Pass', noteKeys: ['pierpass'] },
        {
            badge: 'SI',
            label: 'Shipping Instruction, AES, DG/HAZMAT',
            noteKeys: ['shipping_instruction', 'aes_itn', 'dg_hazmat'],
        },
        { badge: 'PC', label: 'Port Cut, Stages', noteKeys: ['stages'] },
        { badge: 'CC', label: 'Collect Charge', noteKeys: ['ocean_freight'] },
        { badge: 'IV', label: 'Invoice', noteKeys: ['invoice'] },
        { badge: 'CD', label: 'Credit/Debit Statement', noteKeys: ['crdr'] },
    ],
    /** Air Import */
    2: [
        { badge: 'PA', label: 'Pre Alert', noteKeys: ['pre_alert'] },
        { badge: 'C', label: 'Customs', noteKeys: ['customs'], todoKeys: ['customs', 'customs_hold'] },
        { badge: 'CC', label: 'Collect Charge', noteKeys: ['air_freight'] },
        { badge: 'IS', label: 'Import Service Fee', noteKeys: ['import_service_fee'] },
        { badge: 'AN', label: 'Arrival Notice', noteKeys: ['arrival_notice'] },
        { badge: 'DO', label: 'Delivery Order', noteKeys: ['delivery_order'] },
        { badge: 'IV', label: 'Invoice', noteKeys: ['invoice'] },
        { badge: 'CD', label: 'Credit/Debit Statement', noteKeys: ['crdr'] },
    ],
    /** Air Export */
    3: [
        { badge: 'BK', label: 'Booking Confirmation', noteKeys: ['booking_confirmation'] },
        { badge: 'DO', label: 'Delivery Order', noteKeys: ['delivery_order'] },
        {
            badge: 'SI',
            label: 'Shipping Instruction, AES, DG/HAZMAT',
            noteKeys: ['shipping_instruction', 'aes_itn', 'dg_hazmat'],
        },
        { badge: 'PC', label: 'Port Cut, Stages', noteKeys: ['stages'] },
        { badge: 'CC', label: 'Collect Charge', noteKeys: ['air_freight'] },
        { badge: 'IV', label: 'Invoice', noteKeys: ['invoice'] },
        { badge: 'CD', label: 'Credit/Debit Statement', noteKeys: ['crdr'] },
    ],
    /** Trucking */
    4: [
        { badge: 'DO', label: 'Delivery Order', noteKeys: ['delivery_order'] },
        { badge: 'C', label: 'Customs', noteKeys: ['customs'], todoKeys: ['customs', 'customs_hold'] },
        { badge: 'IV', label: 'Invoice', noteKeys: ['invoice'] },
        { badge: 'CD', label: 'Credit/Debit Statement', noteKeys: ['crdr'] },
    ],
};
